import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const creationTypesAdapter = createEntityAdapter({})

const initialState = creationTypesAdapter.getInitialState()

export const creationTypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCreationTypes: builder.query({
            query: () => ({
                url: '/creationTypes/getCreationTypes',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedCreationTypes = responseData.map(creationType => {
                    creationType.id = creationType._id
                    return creationType
                })
                return creationTypesAdapter.setAll(initialState, loadedCreationTypes)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'CreationType', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'CreationType', id}))
                    ]
                } else {
                    return [ { type: 'CreationType', id: 'LIST'}]
                }
            },
        }),
        createNewCreationType: builder.mutation({
            query: initialCreationType => ({
                url: '/creationTypes/createNewCreationType',
                method: 'POST',
                body: {...initialCreationType,}
            }),
            invalidatesTags: [
                { type: 'CreationType', id: "LIST" }
            ] 
        }),
        updateCreationType: builder.mutation({
            query: initialCreationType => ({
                url: '/creationTypes/updateCreationType',
                method: 'PATCH',
                body: {...initialCreationType,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'CreationType', id: arg.id },
                { type: 'CreationType', id: 'LIST' }
            ],
        }),
        deleteCreationType: builder.mutation({
            query: ({id}) => ({
                url: '/creationTypes/deleteCreationType',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CreationType', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetCreationTypesQuery,
    useCreateNewCreationTypeMutation,
    useUpdateCreationTypeMutation,
    useDeleteCreationTypeMutation,
} = creationTypesApiSlice

// returns the query result object
export const selectCreationTypeResult = creationTypesApiSlice.endpoints.getCreationTypes.select()

// create memoized selector
const selectCreationTypesData = createSelector(
    selectCreationTypeResult,
    creationTypeResult => creationTypeResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllCreationTypes,
    selectById: selectCreationTypeById,
    selectIds: selectCreationTypeIds,
} = creationTypesAdapter.getSelectors(state => selectCreationTypesData(state) ?? initialState)